import angular from 'angular'
import moment from 'moment-timezone'

angular.module('admin.offers.edit', []).controller('OffersEditCtrl', OffersEditCtrl)

/** @ngInject */
function OffersEditCtrl(
  $scope,
  $rootScope,
  $state,
  $q,
  $timeout,
  $stateParams,
  OffersService,
  UploadService,
  CoinProductService,
  EventService,
  UserSegmentationService,
  TranslatorService,
  CouponsService,
) {
  var vm = this
  $rootScope.bundleType = 'bundle_title'
  vm.model = {
    dis: true,
  }
  vm.coinProducts = []
  vm.channels = []
  vm.sets = []
  vm.bundles = []
  vm.pathImgH = ''
  vm.id = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false
  vm.waitChannel = true
  vm.waitSet = true
  vm.offersSegmentations = []
  vm.offersTranslations = []
  vm.title = null
  vm.coupons = []

  EventService.listChannels().then(function (result) {
    vm.channels = result.results.filter(function (c) {
      return c.st === 1
    })
  })

  CoinProductService.list().then(function (result) {
    vm.coinProducts = result.results
  })

  OffersService.listOfferSegmentation($stateParams.id).then(function (result) {
    vm.offersSegmentations = result.results
  })

  function loadTranslations() {
    OffersService.listTranslations($stateParams.id).then(function (result) {
      vm.offersTranslations = result.results
    })
  }

  loadTranslations()

  vm.types = [
    {
      id: 1,
      value: 'Coin Product',
    },
    {
      id: 2,
      value: 'Bundle',
    },
    {
      id: 3,
      value: 'Deep Link',
    },
    {
      id: 4,
      value: 'Cash',
    },
    {
      id: 5,
      value: 'Coupon',
    },
  ]
  vm.model.k = vm.types[4].id

  vm.triggers = [
    {
      id: 0,
      value: 'Open App',
    },
    {
      id: 1,
      value: 'Bought Bundle',
    },
    {
      id: 2,
      value: 'Bundle Purchase Failed',
    },
    {
      id: 3,
      value: 'Below Coin Threshold',
    },
    {
      id: 4,
      value: 'Bought Listing',
    },
    {
      id: 5,
      value: 'Listing Purchase Failed',
    },
    {
      id: 6,
      value: 'Fyber Error',
    },
    {
      id: 7,
      value: 'New Level',
    },
    {
      id: 8,
      value: 'Client',
    },
  ]
  vm.model['k-type'] = vm.triggers[0].id

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  if (vm.id !== '0') {
    OffersService.get($stateParams.id).then(function (result) {
      if (result.results.img === undefined) {
        result.results.img = ''
      }
      vm.model = result.results
      vm.title = vm.model.t
      if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
        vm.model['ts-p'] = vm.model['ts-p']
          .toString()
          .substring(0, vm.model['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
        vm.data1 = angular.copy(vm.model['ts-p'])
      }
      if (vm.model['ts-x'] !== undefined && vm.model['ts-x'] !== 0) {
        vm.model['ts-x'] = vm.model['ts-x']
          .toString()
          .substring(0, vm.model['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(vm.model['ts-x']))
        vm.data2 = angular.copy(vm.model['ts-x'])
      }

      if (vm.model['id-cpn']) {
        CouponsService.getByIds(vm.model['id-cpn']).then(function (results) {
          $('#couponSelect').select2('data', results.results[0])
        })
      }

      if (vm.model['id-b']) {
        UserSegmentationService.getBundle(vm.model['id-b']).then(function (resultBundle) {
          var bundle = resultBundle.results
          // $('#e8').select2('data', bundle)

          const channelId = bundle?.['id-ch']
          vm.channelId = channelId
          console.log({channelId:vm.channelId});

          OffersService.listBundlesByChannelId(channelId).then(function (res) {
            vm.bundles = res.results.filter(function (b) {
              return b.st === 1
            })
            vm.model['id-b'] = bundle.id
            console.log({bundleId:bundle.id});

          })
        })

        UserSegmentationService.getBundle(vm.model['id-b']).then(function (response) {})
      }
    })
  } else {
    vm.model.img = ''
  }

  // var makeTranslation = function (t, txt, txt_t, txt_btn, currentTranslations, paramsId, route) {
  //   TranslatorService.translateOfferAllLanguage(t, txt, txt_t, txt_btn).then(function (res) {
  //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

  //     for (var i = 0; i < currentTranslations.length; i++) {
  //       for (var key in res.t.results) {
  //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
  //           languages.remove('ja')
  //         }
  //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
  //           languages.remove('ko')
  //         }
  //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
  //           languages.remove('zh')
  //         }
  //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
  //           languages.remove('zh-TW')
  //         }
  //       }
  //     }

  //     // if (vm.title && vm.title === t && languages.length === 0) {
  //     //   $state.go(route);
  //     //   return
  //     // }

  //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
  //       var promises = []

  //       for (var i = 0; i < currentTranslations.length; i++) {
  //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
  //           var exist = _.find(languages, 'zh')
  //           if (exist) {
  //             promises.push(
  //               OffersService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'SC',
  //                 t: res.t.results.zh,
  //                 'txt-t': res.txt_t ? res.txt_t.results.zh : '',
  //                 txt: res.txt ? res.txt.results.zh : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results.zh : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               OffersService.updateTranslation($stateParams.id, currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.zh,
  //                 'txt-t': res.txt_t ? res.txt_t.results.zh : '',
  //                 txt: res.txt ? res.txt.results.zh : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results.zh : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
  //           var exist = _.find(languages, 'zh-TW')
  //           if (exist) {
  //             promises.push(
  //               OffersService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'TC',
  //                 t: res.t.results['zh-TW'],
  //                 'txt-t': res.txt_t ? res.txt_t.results['zh-TW'] : '',
  //                 txt: res.txt ? res.txt.results['zh-TW'] : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results['zh-TW'] : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               OffersService.updateTranslation($stateParams.id, currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results['zh-TW'],
  //                 'txt-t': res.txt_t ? res.txt_t.results['zh-TW'] : '',
  //                 txt: res.txt ? res.txt.results['zh-TW'] : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results['zh-TW'] : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
  //           var exist = _.find(languages, 'ko')
  //           if (exist) {
  //             promises.push(
  //               OffersService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'KR',
  //                 t: res.t.results.ko,
  //                 'txt-t': res.txt_t ? res.txt_t.results.ko : '',
  //                 txt: res.txt ? res.txt.results.ko : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results.ko : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               OffersService.updateTranslation($stateParams.id, currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ko,
  //                 'txt-t': res.txt_t ? res.txt_t.results.ko : '',
  //                 txt: res.txt ? res.txt.results.ko : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results.ko : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
  //           var exist = _.find(languages, 'ja')
  //           if (exist) {
  //             promises.push(
  //               OffersService.saveTranslation(paramsId, {
  //                 'id-u': 0,
  //                 comm: 'JP',
  //                 t: res.t.results.ja,
  //                 'txt-t': res.txt_t ? res.txt_t.results.ja : '',
  //                 txt: res.txt ? res.txt.results.ja : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results.ja : '',
  //               }),
  //             )
  //           } else {
  //             promises.push(
  //               OffersService.updateTranslation($stateParams.id, currentTranslations[i].id, {
  //                 'id-u': 0,
  //                 t: res.t.results.ja,
  //                 'txt-t': res.txt_t ? res.txt_t.results.ja : '',
  //                 txt: res.txt ? res.txt.results.ja : '',
  //                 'txt-btn': res.txt_btn ? res.txt_btn.results.ja : '',
  //               }),
  //             )
  //           }
  //           continue
  //         }
  //       }

  //       $q.all(promises).then(
  //         function () {
  //           $state.go(route)
  //         },
  //         function (err) {
  //           swal(err.message, '', 'error')
  //         },
  //       )
  //     }

  //     var promises = []

  //     for (var i = 0; i < languages.length; i++) {
  //       if (languages[i] === 'zh' && res.t.results) {
  //         promises.push(
  //           OffersService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'SC',
  //             t: res.t.results.zh,
  //             'txt-t': res.txt_t ? res.txt_t.results.zh : '',
  //             txt: res.txt ? res.txt.results.zh : '',
  //             'txt-btn': res.txt_btn ? res.txt_btn.results.zh : '',
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'zh-TW' && res.t.results) {
  //         promises.push(
  //           OffersService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'TC',
  //             t: res.t.results['zh-TW'],
  //             'txt-t': res.txt_t ? res.txt_t.results['zh-TW'] : '',
  //             txt: res.txt ? res.txt.results['zh-TW'] : '',
  //             'txt-btn': res.txt_btn ? res.txt_btn.results['zh-TW'] : '',
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ko' && res.t.results) {
  //         promises.push(
  //           OffersService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'KR',
  //             t: res.t.results.ko,
  //             'txt-t': res.txt_t ? res.txt_t.results.ko : '',
  //             txt: res.txt ? res.txt.results.ko : '',
  //             'txt-btn': res.txt_btn ? res.txt_btn.results.ko : '',
  //           }),
  //         )
  //       }
  //       if (languages[i] === 'ja' && res.t.results) {
  //         promises.push(
  //           OffersService.saveTranslation(paramsId, {
  //             'id-u': 0,
  //             comm: 'JP',
  //             t: res.t.results.ja,
  //             'txt-t': res.txt_t ? res.txt_t.results.ja : '',
  //             txt: res.txt ? res.txt.results.ja : '',
  //             'txt-btn': res.txt_btn ? res.txt_btn.results.ja : '',
  //           }),
  //         )
  //       }
  //     }

  //     $q.all(promises).then(
  //       function () {
  //         $state.go(route)
  //       },
  //       function (err) {
  //         swal(err.message, '', 'error')
  //       },
  //     )
  //   })
  // }

  vm.save = function () {
    var model = angular.copy(vm.model)
    var isUpdate = model.id !== undefined && model.id !== '' && model.id !== 0
    delete model.ts
    delete model['ts-p']
    delete model['ts-x']

    if (!model.t) {
      swal('Title field is required.', '', 'error')
      return
    }

    if (model.t.length > 30) {
      swal('Title should be 30 characters or fewer', '', 'error')
      return
    }

    if (model['k'] && !model['id-b']) {

      swal(`${vm.channelId?'Bundle':'Channel and Bundle'} field is required ${vm.channelId}`, '', 'error')
      return
    }
    if (model['txt-t'] && model['txt-t'].length > 64) {
      swal('Sub Title should be 64 characters or fewer', '', 'error')
      return
    }

    if (model['txt'] && model['txt'].length > 110) {
      swal('Description should be 110 characters or fewer', '', 'error')
      return
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-p'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-p'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-x'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-x'] = null
    }

    if (!model['txt-btn']) {
      if (model.k === 1) {
        model['txt-btn'] = 'Coin Product Offer'
      } else if (model.k === 2) {
        model['txt-btn'] = 'Buy All'
        var currentBundle = _.find(vm.bundles, { id: vm.model['id-b'] })
        if (currentBundle) {
          model.dis = true
        }
      } else if (model.k === 4) {
        model['txt-btn'] = 'Cash Product Offer'
      } else if (model.k === 5) {
        model['txt-btn'] = 'Coupon Offer'
      }
    }

    var couponId = $('#couponSelect').select2('val')
    if (couponId) {
      model['id-cpn'] = parseInt(couponId)
    }

    var bundleId = parseInt($('#e8').select2('val'))
    if (bundleId) {
      model['id-b'] = bundleId
    }

    if (isUpdate) {
      OffersService.update(model.id, model).then(function (result) {
        if (result.results.st !== 1 && vm.data1 <= new Date()) {
          swal(
            {
              title: 'You want publish it?',
              text: 'Your published_at is bigger than today',
              type: 'warning',
              showCancelButton: true,
              closeOnConfirm: true,
              closeOnCancel: true,
              animation: 'slide-from-top',
            },
            function (isConfirm) {
              if (isConfirm) {
                OffersService.publish(result.results.id).then(function () {
                  // makeTranslation(
                  //   model.t,
                  //   model.txt,
                  //   model['txt-t'],
                  //   model['txt-btn'],
                  //   vm.offersTranslations,
                  //   result.results.id,
                  //   'admin.offers',
                  // )
                  $state.go('admin.offers')
                })
              } else {
                // makeTranslation(
                //   model.t,
                //   model.txt,
                //   model['txt-t'],
                //   model['txt-btn'],
                //   vm.offersTranslations,
                //   result.results.id,
                //   'admin.offers',
                // )
                $state.go('admin.offers')
              }
            },
          )
        } else {
          // makeTranslation(
          //   model.t,
          //   model.txt,
          //   model['txt-t'],
          //   model['txt-btn'],
          //   vm.offersTranslations,
          //   result.results.id,
          //   'admin.offers',
          // )
          $state.go('admin.offers')
        }
      })
    } else {
      model.n = 1
      OffersService.save(model).then(function (result) {
        if (result.results.st !== 1 && vm.data1 <= new Date()) {
          swal(
            {
              title: 'You want publish it?',
              text: 'Your published_at is bigger than today',
              type: 'warning',
              showCancelButton: true,
              closeOnConfirm: true,
              closeOnCancel: true,
              animation: 'slide-from-top',
            },
            function (isConfirm) {
              if (isConfirm) {
                OffersService.publish(result.results.id).then(function () {
                  // makeTranslation(
                  //   model.t,
                  //   model.txt,
                  //   model['txt-t'],
                  //   model['txt-btn'],
                  //   vm.offersTranslations,
                  //   result.results.id,
                  //   'admin.offers',
                  // )
                  $state.go('admin.offers')
                })
              } else {
                // makeTranslation(
                //   model.t,
                //   model.txt,
                //   model['txt-t'],
                //   model['txt-btn'],
                //   vm.offersTranslations,
                //   result.results.id,
                //   'admin.offers',
                // )
                $state.go('admin.offers')
              }
            },
          )
        } else {
          // makeTranslation(
          //   model.t,
          //   model.txt,
          //   model['txt-t'],
          //   model['txt-btn'],
          //   vm.offersTranslations,
          //   result.results.id,
          //   'admin.offers',
          // )
          $state.go('admin.offers')
        }
      })
    }
  }

  vm.addSegmentation = function () {
    vm.segmentationId = parseInt($('#e15').select2('val'))

    OffersService.addOfferSegmentation($stateParams.id, vm.segmentationId).then(
      function () {
        OffersService.listOfferSegmentation($stateParams.id).then(function (result) {
          vm.offersSegmentations = result.results
        })
      },
      function () {
        swal('This user segmentation already exists', '', 'error')
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          OffersService.removeOfferSegmentation($stateParams.id, id).then(function () {
            OffersService.listOfferSegmentation($stateParams.id).then(function (result) {
              vm.offersSegmentations = result.results
            })
          })
        } else {
          return
        }
      },
    )
  }

  vm.cancel = function () {
    $state.go('admin.offers')
  }

  vm.translate = {}
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslate').modal('show')
  }

  vm.classDisabled = function () {
    if (
      !vm.translate.comm ||
      !vm.translate.t ||
      !vm.translate['txt-t'] ||
      !vm.translate['txt'] ||
      !vm.translate['txt-btn']
    ) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      OffersService.updateTranslation($stateParams.id, vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      OffersService.saveTranslation($stateParams.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslate').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    OffersService.getTranslation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslate').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          OffersService.removeTranslation($stateParams.id, id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslate').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadH = function (item) {
    if (vm.pathImgH.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadH = true
    UploadService.save('offers', vm.pathImgH, 'img', item.id).then(function (fileName) {
      vm.loadH = false
      item.img = fileName
    })
  }


  $scope.$watch('vm.channelId', function (newVal, oldVal) {
    if (!newVal) return

    vm.waitBundles = true
    vm.model['id-b'] = null

    console.log(vm.channelId,newVal);
    OffersService.listBundlesByChannelId(newVal).then(function (res) {
      vm.bundles = res.results.filter(function (b) {
        return b.st === 1
      })
      vm.waitBundles = false
    })
  })


  // var watch = $scope.$watch('vm.channelId', function (newVal, oldVal) {
  //   if (newVal === oldVal) {
  //     return
  //   }

  //   if (newVal === null) {
  //     return
  //   }

  //   EventService.listSets(newVal).then(function (response) {
  //     vm.sets = response.results
  //     vm.waitChannel = false
  //   })
  // })

  // var watch1 = $scope.$watch('vm.setId', function (newVal, oldVal) {
  //   if (newVal === oldVal) {
  //     return
  //   }

  //   if (newVal === null) {
  //     return
  //   }

  //   UserSegmentationService.listBundles(newVal).then(function (response) {
  //     vm.bundles = response.results
  //     vm.waitSet = false
  //   })
  // })

  var watch2 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch3 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
    watch3()
  })

  $('#e15').select2('data', [])
}
